function n(r) {
  try {
    return JSON.parse(r), !0;
  } catch {
    return !1;
  }
}
function e(r, t) {
  if (!r) return t;
  try {
    return JSON.parse(r);
  } catch {
    return t;
  }
}
export {
  n as isJsonString,
  e as parseJson
};
